/* SURFACE REGISTRY — one route per surface (spec §3.2, S1–S11).
 * `primary: true` surfaces appear in the bottom tab bar; the rest live under "More". */
import { renderSkippy } from './surfaces/skippy';
import { renderFlags } from './surfaces/flags';
import {
  renderToday,
  renderActions,
  renderUpdates,
  renderHealth,
  renderFinances,
  renderBusiness,
  renderCalendar,
  renderTodos,
  renderShopping,
  renderExtras,
  renderSchool,
  renderSettings,
} from './surfaces/views';

export interface Surface {
  id: string; // route path (hash)
  title: string;
  icon: string; // icon key
  primary?: boolean; // shows in the bottom tab bar
  render: (root: HTMLElement) => Promise<void>;
}

export const SURFACES: Surface[] = [
  { id: 'skippy', title: 'Skippy', icon: 'skippy', primary: true, render: renderSkippy },
  { id: 'today', title: 'Today', icon: 'today', primary: true, render: renderToday },
  { id: 'actions', title: 'Actions', icon: 'actions', primary: true, render: renderActions },
  { id: 'health', title: 'Health', icon: 'health', primary: true, render: renderHealth },
  { id: 'updates', title: 'Updates', icon: 'updates', render: renderUpdates },
  { id: 'flags', title: 'Flags', icon: 'updates', render: renderFlags },
  { id: 'finances', title: 'Finances', icon: 'finances', render: renderFinances },
  { id: 'business', title: 'Business', icon: 'business', render: renderBusiness },
  { id: 'calendar', title: 'Calendar', icon: 'calendar', render: renderCalendar },
  { id: 'todos', title: 'To-Do', icon: 'todo', render: renderTodos },
  { id: 'shopping', title: 'Shopping', icon: 'shopping', render: renderShopping },
  { id: 'extras', title: 'Extras', icon: 'extras', render: renderExtras },
  { id: 'school', title: 'School', icon: 'school', render: renderSchool },
  { id: 'settings', title: 'Settings', icon: 'settings', render: renderSettings },
];

export const DEFAULT_SURFACE = 'skippy';

export function findSurface(id: string): Surface {
  return SURFACES.find((s) => s.id === id) ?? SURFACES[0];
}
